export enum ChangeTagsType {
  Add = 'add',
  Remove = 'remove',
  Update = 'update',
}
